/* GiftHub delivery sheet steps. Watches the cart's "Schedule your delivery" sheet (gh-delivery-scheduler.js) and counts
   which steps a shopper reaches each time it opens: open, area, postcode, date, slot, then save, later or close.
   It only reads the sheet; it never changes it. Sent to the Admin Center as counts: the step, the sheet's area key
   and phone-or-desktop. No postcode, date, time, name or phone leaves the page. */
(function () {
  "use strict";
  if (window.__ghDsTrack) return;
  window.__ghDsTrack = true;
  var ENDPOINT = "https://gifthub-ai-gift-finder.gifthub-my.workers.dev/funnel";
  var sheet = null, open = false, seen = {}, queue = [], ending = "";

  function device() { return window.matchMedia && matchMedia("(max-width: 749px)").matches ? "mobile" : "desktop"; }
  function region() {
    var on = sheet && sheet.querySelector("[data-ds-area].is-on");
    return on ? String(on.getAttribute("data-ds-area") || "").toLowerCase() : "";
  }
  function step(name) {
    if (!open || seen[name]) return;
    seen[name] = 1;
    queue.push({ t: "ds", step: name, region: region(), device: device() });
  }
  function flush() {
    if (!queue.length) return;
    // The sheet picks its area just after it opens, so an "open" sent without one takes the area it ended on.
    var r = region();
    queue.forEach(function (e) { if (!e.region) e.region = r; });
    var body = JSON.stringify({ events: queue.splice(0, 15) });
    try {
      // text/plain keeps this a simple request, so a closing tab can still send it.
      if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" })))) {
        fetch(ENDPOINT, { method: "POST", body: body, mode: "cors", credentials: "omit", keepalive: true }).catch(function () {});
      }
    } catch (e) {}
    if (queue.length) flush();
  }
  function opened() { open = true; seen = {}; ending = ""; step("open"); }
  function closed() {
    if (!open) return;
    step(ending || "close");
    open = false;
    flush();
  }
  function shown(el) { return !el.hidden && (el.classList.contains("is-open") || el.getAttribute("aria-hidden") !== "true"); }
  function watch(el) {
    if (sheet === el) return;
    sheet = el;
    if (shown(el)) opened();
    new MutationObserver(function () { if (!shown(el)) closed(); else if (!open) opened(); })
      .observe(el, { attributes: true, attributeFilter: ["hidden", "class", "aria-hidden"] });
    el.addEventListener("keydown", function (e) { if (e.key === "Escape") ending = ""; }, true);
    el.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      // The X and the dimmed backdrop both close; a save or "later" that failed is then just a close.
      if (e.target.closest("[data-ds-close]")) { ending = ""; return; }
      var b = e.target.closest("button");
      if (!b || b.classList.contains("is-off") || b.disabled) return;
      if (b.hasAttribute("data-ds-area")) step("area");
      else if (b.hasAttribute("data-ds-date")) step("date");
      else if (b.hasAttribute("data-ds-slot")) step("slot");
      // Save and "later" only count once the sheet actually closes after them (a missing field keeps it open).
      else if (b.classList.contains("gh-ds__go")) ending = "save";
      else if (b.classList.contains("gh-ds__later")) ending = "later";
    }, true);
    el.addEventListener("input", function (e) {
      var t = e.target;
      if (!t || t.id !== "gh-ds-pc" || !/^\d{5}$/.test(String(t.value || "").trim())) return;
      // Counted only when the sheet accepts it (no "we don't deliver there" message).
      setTimeout(function () { if (!el.querySelector(".gh-ds__pc.is-bad") && !el.classList.contains("gh-ds--needpc")) step("postcode"); }, 400);
    }, true);
  }
  function find() { var el = document.querySelector(".gh-ds"); if (el) watch(el); return !!el; }
  if (!find()) {
    var mo = new MutationObserver(function () { if (find()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  // Leaving the page with the sheet open: a save or "later" that is navigating to checkout, else a close.
  window.addEventListener("pagehide", closed);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flush(); });
})();
